export default __webpack_public_path__ + "static/media/ava-03.d5247c0b.png";